/** Adaptive probe inserted when sentiment is negative on a question step. */
export const ACCOUNTABILITY_PROBE_ID = "accountability-probe";

export function shouldInsertAccountabilityProbe(
  stepId: string,
  skipped: boolean,
  sentimentScore: number
): boolean {
  if (skipped || sentimentScore >= 0) return false;
  return stepId === "q1" || stepId === "q2" || stepId === "q3" || stepId === "q4";
}

export function insertAdaptiveStep(
  queue: string[],
  afterIndex: number,
  stepId: string
): string[] {
  if (queue.includes(stepId)) return queue;
  const next = [...queue];
  next.splice(afterIndex + 1, 0, stepId);
  return next;
}
